/* Gallery V2 — filtering + project detail.
   Filters are three independent dimensions (family, finish, type) that combine
   as an AND. Everything reads the rendered cards, so a metaobject-backed render
   works unchanged. */
(function () {
  'use strict';

  var root = document.querySelector('[data-gv2]');
  if (!root) return;

  var grid    = root.querySelector('[data-gv2-grid]');
  var items   = Array.prototype.slice.call(root.querySelectorAll('[data-gv2-item]'));
  var quick   = Array.prototype.slice.call(root.querySelectorAll('[data-gv2-quick]'));
  var selects = Array.prototype.slice.call(root.querySelectorAll('[data-gv2-select]'));
  var status  = root.querySelector('[data-gv2-status]');
  var clearBtn = root.querySelector('[data-gv2-clear]');
  var empty   = root.querySelector('[data-gv2-empty]');
  var lb      = root.querySelector('[data-gv2-lb]');
  var lbImg   = root.querySelector('[data-gv2-lb-img]');
  var lbMeta  = root.querySelector('[data-gv2-lb-meta]');

  if (!grid || !items.length) return;

  // The theme's main.site-main is a stacking context at z-index 500, below the
  // sticky header at 1110, so the dialog has to live on <body> to sit on top.
  if (lb && lb.parentElement !== document.body) document.body.appendChild(lb);

  /* ---------------- Filtering ---------------- */

  var state = { family: '', finish: '', type: '' };
  var visible = items.slice();

  var FINISH_LABELS = { gloss: 'Gloss', matte: 'Matte', satin: 'Satin' };

  function labelFor(dim, value) {
    // family and type labels come from their select, so Liquid stays the single
    // source of truth and new project types need no JS change
    if (dim === 'family' || dim === 'type') {
      var opt = root.querySelector('[data-gv2-select="' + dim + '"] option[value="' + value + '"]');
      // strip the trailing "(n)" count from the option text
      if (opt) return opt.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
    }
    if (dim === 'finish') return FINISH_LABELS[value] || value;
    return value;
  }

  function matches(li) {
    if (state.family && li.getAttribute('data-family') !== state.family) return false;
    if (state.finish && li.getAttribute('data-finish') !== state.finish) return false;
    if (state.type   && li.getAttribute('data-type')   !== state.type)   return false;
    return true;
  }

  function activeCount() {
    return (state.family ? 1 : 0) + (state.finish ? 1 : 0) + (state.type ? 1 : 0);
  }

  function apply() {
    visible = [];
    items.forEach(function (li) {
      var on = matches(li);
      li.hidden = !on;
      if (on) visible.push(li);
    });

    // A quick chip is active when it alone describes the current selection.
    quick.forEach(function (btn) {
      var spec = btn.getAttribute('data-gv2-quick');
      var on;
      if (spec === 'all') {
        on = activeCount() === 0;
      } else {
        var bits = spec.split(':');
        on = state[bits[0]] === bits[1];
      }
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    selects.forEach(function (sel) {
      sel.value = state[sel.getAttribute('data-gv2-select')] || '';
    });

    if (empty) empty.hidden = visible.length !== 0;
    if (clearBtn) clearBtn.hidden = activeCount() === 0;

    if (status) {
      var parts = [];
      ['family', 'finish', 'type'].forEach(function (d) {
        if (state[d]) parts.push(labelFor(d, state[d]));
      });
      var noun = visible.length === 1 ? 'project' : 'projects';
      status.textContent = parts.length
        ? visible.length + ' ' + noun + ' — ' + parts.join(' + ')
        : visible.length + ' ' + noun + ' — all';
    }
  }

  quick.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var spec = btn.getAttribute('data-gv2-quick');
      if (spec === 'all') {
        state.family = state.finish = state.type = '';
      } else {
        var bits = spec.split(':');
        // tapping an active quick filter turns it back off
        state[bits[0]] = state[bits[0]] === bits[1] ? '' : bits[1];
      }
      apply();
    });
  });

  selects.forEach(function (sel) {
    sel.addEventListener('change', function () {
      state[sel.getAttribute('data-gv2-select')] = sel.value;
      apply();
    });
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      state.family = state.finish = state.type = '';
      apply();
    });
  }

  apply();

  /* ---------------- Project detail ---------------- */

  var lastFocused = null;
  var current = -1;

  function metaFor(btn) {
    var title = btn.getAttribute('data-product-title');
    var url   = btn.getAttribute('data-product-url');
    if (!title || !url) return '';
    var img = btn.getAttribute('data-product-img');
    return '' +
      '<div class="gv2-attr gv2-attr--detail">' +
        '<p class="gv2-attr__eyebrow">Used on this project</p>' +
        '<a class="gv2-attr__link" href="' + url + '">' +
          (img ? '<span class="gv2-attr__media"><img src="' + img + '" alt="" width="160" height="160" loading="lazy"></span>' : '') +
          '<span class="gv2-attr__text">' +
            '<span class="gv2-attr__name">' + title + '</span>' +
            '<span class="gv2-attr__cta">Shop product</span>' +
          '</span>' +
        '</a>' +
      '</div>';
  }

  function show(index) {
    if (!visible.length) return;
    current = (index + visible.length) % visible.length;
    var btn = visible[current].querySelector('[data-gv2-open]');
    if (!btn) return;
    lbImg.src = btn.getAttribute('data-src');
    lbImg.alt = btn.getAttribute('data-alt') || '';
    lbMeta.innerHTML = metaFor(btn);
  }

  function open(li) {
    lastFocused = document.activeElement;
    show(visible.indexOf(li));
    lb.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    // focus the close button, not the backdrop div, which also carries data-gv2-close
    var closeBtn = lb.querySelector('.gv2-lb__btn--close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    lb.hidden = true;
    lbImg.src = '';
    lbMeta.innerHTML = '';
    document.documentElement.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  items.forEach(function (li) {
    var btn = li.querySelector('[data-gv2-open]');
    if (btn) btn.addEventListener('click', function () { open(li); });
  });

  Array.prototype.forEach.call(lb.querySelectorAll('[data-gv2-close]'), function (el) {
    el.addEventListener('click', close);
  });
  var prev = lb.querySelector('[data-gv2-prev]');
  var next = lb.querySelector('[data-gv2-next]');
  if (prev) prev.addEventListener('click', function () { show(current - 1); });
  if (next) next.addEventListener('click', function () { show(current + 1); });

  document.addEventListener('keydown', function (e) {
    if (lb.hidden) return;
    if (e.key === 'Escape')     { close(); }
    if (e.key === 'ArrowLeft')  { show(current - 1); }
    if (e.key === 'ArrowRight') { show(current + 1); }
    if (e.key === 'Tab') {
      var f = lb.querySelectorAll('button, a[href]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
